{
  "reports": {
    "filterLabels": {
      "branch": "وحدة الشراء",
      "region": "المنطقة",
      "category": "الفئة",
      "supplier": "المورد",
      "budgetPeriod": "فترة الميزانية",
      "open": "السجلات المفتوحة",
      "late": "السجلات المتأخرة",
      "overdue": "السجلات المتجاوزة للموعد",
      "issued": "الأوامر الصادرة",
      "exclude_cancelled": "الأوامر الملغاة",
      "awarded": "طلبات عروض الأسعار التي تمت ترسيتها",
      "no_award": "طلبات عروض الأسعار المغلقة دون ترسية",
      "decided": "طلبات عروض الأسعار التي صدر فيها قرار (زمن الدورة)",
      "currency": "العملة",
      "attribution": "النسبة إلى فئة",
      "attributedCategory": "منسوب إلى فئة",
      "unattributedCategory": "غير منسوب — فئات مختلطة أو فئة غير محددة",
      "categoryAndUnattributed": "{{categories}}، إضافةً إلى كل ما يقع ضمن «{{unattributed}}»",
      "only": "فقط",
      "excluded": "مستبعدة"
    },
    "budgetOutcome": {
      "released": "تم تحرير الحجز",
      "held": "ما زال محجوزاً",
      "reserved": "المحجوز لهذا الطلب",
      "givenBack": "المُعاد إلى الميزانية",
      "stillHeld": "ما زال محجوزاً لهذا الطلب",
      "note": "هذا الطلب منتهٍ ولم يعد يخصم من هذه الميزانية. هذه هي المبالغ التي سجّلها دفتر الميزانية له."
    }
  }
}
